module.exports = __webpack_public_path__ + "static/media/SERVICE_REQUISITION_1.b1c9ed4c.png";